<p-table #dt [columns]="cols" [value]="listArchives | async">
    <ng-template pTemplate="caption">
       
</ng-template>



    <ng-template pTemplate="header" let-colsVaraible>
        <tr>
            <th *ngFor="let col of colsVaraible"  [style.width]="col.width">
                {{col.header}}
            </th>
            <th style="width: 100px;" >Fiche Client</th>
        
        </tr>

      

        
        <tr>
            <th *ngFor="let col of cols"  [ngSwitch]="col.field">
             
                <p-dropdown *ngSwitchCase="'type'" [options]="types" [style]="{'width':'100%'}" (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>
                <input style="width:100% ;" *ngSwitchDefault pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">

           </th>

           


           <th style="width: 100px;" > </th>
        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-row let-colsVaraible="columns">
        <tr>
         

            <td *ngFor="let col of colsVaraible"  [ngSwitch]="col.field">
                <span *ngSwitchCase="'dateEdit'"> {{row[col.field] | date }}</span> 
                <span *ngSwitchDefault>  {{row[col.field]}}</span> 
                <div  *ngSwitchCase="'type'">{{convertType(row[col.field])}} </div>
            </td>


            <td  >
              <mat-icon  [routerLink]="['/add-exhibitor',{idClient:row.idClient}]">folder_open</mat-icon> 
            </td>



        </tr>
    </ng-template>
   
  
</p-table>